console.log('Custom JS loaded');

const shopifyRoot = window.Shopify?.routes?.root || '/';

// ============================================================================
// INTERCEPTOR PARA "VER CARRITO" - CERRAR NOTIFICATION Y ABRIR CART-DRAWER
// ============================================================================
(function() {
  'use strict';
  
  // Interceptar clicks en CUALQUIER botón [aria-controls="cart-drawer"]
  document.addEventListener('click', function(e) {
    // Buscar si el click fue en o dentro de un botón que controla cart-drawer
    const button = e.target.closest('[aria-controls="cart-drawer"]');
    
    if (button) {
      // Buscar el cart-notification-drawer
      const cartNotification = document.querySelector('cart-notification-drawer');
      
      // Si cart-notification está abierto, interceptar
      if (cartNotification && cartNotification.hasAttribute('open')) {
        console.log('🔘 Click en Ver Carrito - Cerrando notification');
        
        // CRÍTICO: Prevenir que el botón ejecute su acción default
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        
        // Cerrar cart-notification
        cartNotification.hide();
        
        // Esperar a que cierre y abrir cart-drawer
        setTimeout(function() {
          const cartDrawer = document.getElementById('cart-drawer');
          if (cartDrawer) {
            console.log('✅ Abriendo cart-drawer');
            cartDrawer.show();
          }
        }, 300); // Esperar a que termine la animación de cierre
        
        return false;
      }
    }
  }, true); // Capture phase para ejecutar ANTES que el tema
  
})();

// ============================================================================
// PREVENIR CART-NOTIFICATION AL AGREGAR DESDE CART-DRAWER
// ============================================================================
(function() {
  'use strict';
  
  let addingFromCartDrawer = false;
  
  // Marcar cuando estamos agregando desde cart-drawer
  window.setAddingFromCartDrawer = function(value) {
    addingFromCartDrawer = value;
  };
  
  // Interceptar variant:add para prevenir que se abra cart-notification
  document.addEventListener('variant:add', function(e) {
    if (addingFromCartDrawer) {
      // Cerrar cart-notification si se abrió
      setTimeout(function() {
        const cartNotification = document.querySelector('cart-notification-drawer');
        if (cartNotification && cartNotification.hasAttribute('open')) {
          cartNotification.hide();
        }
      }, 50);
    }
  });
  
})();


window.scrollCarousel = function(carouselId, direction, event) {
  if (event && typeof event.stopPropagation === 'function') {
    event.stopPropagation();
  }
  
  const carousel = document.getElementById(carouselId);
  if (!carousel) return false;
  
  const item = carousel.querySelector('.item');
  if (!item) return false;
  
  const scrollAmount = item.offsetWidth + 8;
  carousel.scrollBy({ 
    left: direction === 'prev' ? -scrollAmount : scrollAmount, 
    behavior: 'smooth' 
  });
  
  return false;
};

function updateCarouselButtons() {
  ['empty', 'full'].forEach(function(type) {
    const carousel = document.getElementById(type + '-carousel');
    const prevBtn = document.getElementById(type + '-prev-btn');
    const nextBtn = document.getElementById(type + '-next-btn');
    
    if (!carousel || !prevBtn || !nextBtn) return;
    
    const maxScroll = carousel.scrollWidth - carousel.offsetWidth;
    prevBtn.disabled = carousel.scrollLeft <= 1;
    nextBtn.disabled = carousel.scrollLeft >= maxScroll - 1;
    
    carousel.onscroll = function() {
      prevBtn.disabled = carousel.scrollLeft <= 1;
      nextBtn.disabled = carousel.scrollLeft >= maxScroll - 1;
    };
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function() {
    setTimeout(updateCarouselButtons, 200);
  });
} else {
  setTimeout(updateCarouselButtons, 200);
}

document.addEventListener('dialog:after-show', function(e) {
  if (e.target?.id === 'cart-drawer') {
    setTimeout(updateCarouselButtons, 300);
  }
});

document.addEventListener('cart:refresh', function() {
  setTimeout(updateCarouselButtons, 500);
});

// ============================================================================
// CONVERSION BAR & COUNTDOWN
// ============================================================================
(function() {
  'use strict';
  
  let countdownInterval = null;
  let messageInterval = null;
  let pollingInterval = null;
  let lastKnownCount = -1;
  let isDrawerOpen = false;
  let isFetching = false;
  let initialCheckTimeout = null;
  let refreshCheckTimeout = null;
  
  let messages;
const currentLang = document.documentElement.lang || 'en';

if (currentLang === 'es') {
  messages = [
    "Tu pedido, casi confirmado.",
    "Completa y recibe más rápido.",
    "No lo dejes a medias.",
    "Da el último paso.",
    "Ya casi lo tienes.",
    "Tu pedido está casi listo.",
    "Solo un paso más.",
    "¡Casi tuyo! Completa tu pedido.",
    "Transforma tus eventos hoy."
  ];
} else if (currentLang === 'ar') {
  messages = [
    "طلبك شبه مؤكد.",
    "أكمل واستلم بشكل أسرع.",
    "لا تتركه في منتصف الطريق.",
    "خذ الخطوة الأخيرة.",
    "أنت على وشك الحصول عليه.",
    "طلبك جاهز تقريبًا.",
    "خطوة واحدة فقط.",
    "تقريبًا لك! أكمل طلبك.",
    "حوّل فعالياتك اليوم."
  ];
} else {
  messages = [
    "Your order, almost confirmed.",
    "Complete and receive faster.",
    "Don't leave it halfway.",
    "Take the final step.",
    "You almost have it.",
    "Your order is almost ready.",
    "Just one more step.",
    "Almost yours! Complete your order.",
    "Transform your events today."
  ];
}
  
  function getElements() {
    return {
      wrapper: document.querySelector('.conversion-wrapper'),
      messageEl: document.getElementById('conv-message'),
      progressEl: document.getElementById('conv-progress'),
      hoursEl: document.getElementById('conv-hours'),
      minutesEl: document.getElementById('conv-minutes'),
      secondsEl: document.getElementById('conv-seconds'),
    };
  }
  
  function showMessage(messageEl) {
    if (!messageEl) return;
    const randomIndex = Math.floor(Math.random() * messages.length);
    messageEl.textContent = messages[randomIndex];
  }
  
  function updateProgress(progressEl, count) {
    if (!progressEl) return;
    
    let percent = 0; 
    if (count >= 2) { 
      percent = 100;
    } else if (count === 1) {
      percent = 60;
    }

    const currentWidth = parseFloat(progressEl.style.width) || 0;

    // Si el progreso va hacia arriba o es igual, aplicar transición
    if (percent >= currentWidth) {
      progressEl.style.transition = 'width 1s ease';
      progressEl.style.width = percent + '%';
    } else {
      // Si retrocede, sin transición
      progressEl.style.transition = 'none';
      void progressEl.offsetWidth;
      progressEl.style.width = percent + '%';
    }

    progressEl.setAttribute('aria-valuenow', percent); 
  }
  
  function initTimer() {
    const now = new Date();
    const stored = localStorage.getItem('countdownEnd');
    let endTime;
    
    if (stored) {
      endTime = new Date(stored);
      if (endTime <= now) {
        endTime = new Date(now.getTime() + (4.5 * 60 * 60 * 1000));
        localStorage.setItem('countdownEnd', endTime.toISOString());
      }
    } else {
      endTime = new Date(now.getTime() + (4.5 * 60 * 60 * 1000));
      localStorage.setItem('countdownEnd', endTime.toISOString());
    }
    
    return endTime;
  }
  
  const countdownEnd = initTimer();
  
  function updateCountdown(els) {
    if (!els.hoursEl) return;
    
    const now = new Date();
    const diff = countdownEnd - now;
    
    if (diff <= 0) {
      els.hoursEl.textContent = '00';
      els.minutesEl.textContent = '00';
      els.secondsEl.textContent = '00';
      if (countdownInterval) {
        clearInterval(countdownInterval);
        countdownInterval = null;
      }
      return;
    }
    
    const totalSeconds = Math.floor(diff / 1000); 
    
    const hours = Math.floor(totalSeconds / (60 * 60));
    const minutes = Math.floor((totalSeconds % (60 * 60)) / 60);
    const seconds = Math.floor(totalSeconds % 60);
    
    els.hoursEl.textContent = String(hours).padStart(2, '0');
    els.minutesEl.textContent = String(minutes).padStart(2, '0');
    els.secondsEl.textContent = String(seconds).padStart(2, '0');
  }
  
  function startIntervals(cartCount) {
    const els = getElements();
    if (!els.wrapper) return;

    // Actualizar progreso ANTES de detener intervalos
    updateProgress(els.progressEl, cartCount);
    
    // Si ya hay mensaje, no actualizarlo (evita parpadeo)
    if (!els.messageEl.textContent || els.messageEl.textContent.trim() === '') {
      showMessage(els.messageEl);
    }
    
    updateCountdown(els);
    
    // Detener intervalos existentes
    stopIntervals();
    
    // Reiniciar intervalos
    countdownInterval = setInterval(function() {
      const currentEls = getElements();
      updateCountdown(currentEls);
    }, 1000); 
    
    messageInterval = setInterval(function() {
      const currentEls = getElements();
      showMessage(currentEls.messageEl);
    }, 5000);
  }
  
  function stopIntervals() {
    if (countdownInterval) {
      clearInterval(countdownInterval);
      countdownInterval = null;
    }
    if (messageInterval) {
      clearInterval(messageInterval);
      messageInterval = null;
    }
  }
  
  function stopPolling() {
    if (pollingInterval) {
      clearInterval(pollingInterval);
      pollingInterval = null;
    }
  }
  
  async function checkCartAndUpdate() {
    if (!isDrawerOpen) return;
    if (isFetching) return;
    isFetching = true;
    
    try {
      const response = await fetch(`${shopifyRoot}cart.js`);
      if (!response.ok) throw new Error('HTTP ' + response.status);
      const cart = await response.json();
      if (!isDrawerOpen) return;
      const cartCount = cart.item_count || 0;
      
      const els = getElements();
      if (!els.wrapper) return;
      
      // Solo salir si el conteo NO ha cambiado Y ya se mostró la barra
      if (cartCount === lastKnownCount && cartCount > 0 && els.wrapper.style.display === 'block') {
        return;
      }
      
      lastKnownCount = cartCount;
      
      if (cartCount === 0) {
        els.wrapper.style.display = 'none';
        stopIntervals();
      } else {
        els.wrapper.style.display = 'block';
        startIntervals(cartCount);
      }
      
      document.dispatchEvent(new CustomEvent('cart:count-changed', {
        detail: { count: cartCount }
      }));
      
    } catch (error) {
      console.error('Error checking cart:', error);
    } finally {
      isFetching = false;
    }
  }
  
  document.addEventListener('toggle', function(e) {
    if (!e.target || e.target.id !== 'cart-drawer') return;
    if (e.target.open) {
      isDrawerOpen = true;
      lastKnownCount = -1;
      clearTimeout(initialCheckTimeout);
      initialCheckTimeout = setTimeout(checkCartAndUpdate, 300);
      stopPolling();
      pollingInterval = setInterval(checkCartAndUpdate, 500);
    } else {
      isDrawerOpen = false;
      lastKnownCount = -1;
      clearTimeout(initialCheckTimeout); initialCheckTimeout = null;
      clearTimeout(refreshCheckTimeout); refreshCheckTimeout = null;
      stopPolling();
      stopIntervals();
    }
  }, true);
  
  document.addEventListener('cart:refresh', function() {
    if (isDrawerOpen) {
      clearTimeout(refreshCheckTimeout);
      refreshCheckTimeout = setTimeout(checkCartAndUpdate, 200);
    }
  });
  
})();
// Silenciar errores cosméticos y advertencias de Google Analytics obsoleto
document.addEventListener('DOMContentLoaded', () => {
  const originalError = console.error;
  const originalWarn = console.warn;
  const originalLog = console.log;

  // Bloquear Errores
  console.error = function(...args) {
    const msg = args.join(' ');
    if (msg.includes('MegaMenuPromoCarousel') || msg.includes('_updateControlsColor') || msg.includes('Google Analytics stub')) return;
    originalError.apply(console, args);
  };

  // Bloquear Advertencias (Warn)
  console.warn = function(...args) {
    const msg = args.join(' ');
    if (msg.includes('Google Analytics stub')) return;
    originalWarn.apply(console, args);
  };

  // Bloquear Logs de información
  console.log = function(...args) {
    const msg = args.join(' ');
    if (msg.includes('Google Analytics stub')) return;
    originalLog.apply(console, args);
  };
});

// ============================================================================
// PRODUCTOS COMPLEMENTARIOS - POLLING
// ============================================================================
(function() {
  'use strict';
  
  let carouselStartTimeout = null;
  let carouselRefreshTimeout = null;
  let isCarouselUpdating = false;
  let pendingCarouselUpdate = false;
  let isCarouselDrawerOpen = false;
  let lastCartItemsString = '';

  function shopifyImageUrl(src, width) {
    if (!src) return null;
    try {
      const url = new URL(src, window.location.origin);
      url.searchParams.set('width', String(width));
      return url.toString();
    } catch (e) { return src; }
  }

  async function loadComplementaryProducts(forceUpdate = false) {
    if (!isCarouselDrawerOpen) return;
    if (isCarouselUpdating) {
      if (forceUpdate) pendingCarouselUpdate = true;
      return;
    }
    isCarouselUpdating = true;
    
    const carousel = document.getElementById('full-carousel');
    const container = document.getElementById('full-carousel-container');
    
    if (!carousel || !container) {
      isCarouselUpdating = false;
      return;
    }
    
    try {
      const cart = await fetch(`${shopifyRoot}cart.js`).then(r => r.json());
      
      if (!cart.items || cart.items.length === 0) {
        isCarouselUpdating = false;
        return;
      }
      
      // Crear string único del carrito para detectar cambios
      const currentCartString = cart.items.map(item => item.product_id).sort().join(',');
      
      // Si el carrito no cambió y no es forzado, salir
      if (currentCartString === lastCartItemsString && !forceUpdate) {
        isCarouselUpdating = false;
        return;
      }
      
      lastCartItemsString = currentCartString;
      
      const itemsInCart = cart.items.length;
      const limitPerProduct = itemsInCart === 1 ? 10 : 3;
      const maxTotal = 12;
      
      const cartProductIds = cart.items.map(item => item.product_id);
      
      let allProducts = [];
      const seenIds = new Set();
      
      for (const item of cart.items) {
        if (allProducts.length >= maxTotal) break;
        
        try {
          const url = `${shopifyRoot}recommendations/products.json?product_id=${item.product_id}&limit=${limitPerProduct}&intent=complementary`;
          const data = await fetch(url).then(r => r.json());
          
          if (data.products && data.products.length > 0) {
            data.products.forEach(function(product) {
              if (allProducts.length < maxTotal && 
                  !seenIds.has(product.id) && 
                  !cartProductIds.includes(product.id) &&
                  product.available) {
                allProducts.push(product);
                seenIds.add(product.id);
              }
            });
          }
        } catch (err) {
          console.error('Error fetching recommendations:', err);
        }
      }
      
      if (allProducts.length === 0) {
        isCarouselUpdating = false;
        return;
      }
      
      carousel.innerHTML = allProducts.map(function(p) {
        const price = (p.price / 100).toFixed(2);
        const variantId = p.variants && p.variants[0] ? p.variants[0].id : '';
        
        return `
          <div class="item">
            <div class="cart-rec-product">
              <div class="cart-rec-product__image-wrapper">
                ${p.featured_image ? `<img src="${shopifyImageUrl(p.featured_image, 220)}" alt="${p.title}" class="cart-rec-product__image" loading="lazy">` : ''}
              </div>
              <h4 class="cart-rec-product__title">${p.title}</h4>
              <p class="cart-rec-product__price">$${price} USD</p>
              <button type="button" class="cart-rec-product__button" onclick="window.cartAddProduct(${variantId}, this)">AÑADIR</button>
            </div>
          </div>
        `;
      }).join('');
      
      container.setAttribute('data-total-items', allProducts.length);
      
      const showArrows = allProducts.length > 2;
      const prevBtn = document.getElementById('full-prev-btn');
      const nextBtn = document.getElementById('full-next-btn');
      
      if (prevBtn && nextBtn) {
        prevBtn.style.display = showArrows ? 'flex' : 'none';
        nextBtn.style.display = showArrows ? 'flex' : 'none';
      }
      
      if (typeof updateCarouselButtons === 'function') {
        setTimeout(updateCarouselButtons, 150);
      }
      
    } catch (error) {
      console.error('Error in loadComplementaryProducts:', error);
    } finally {
      isCarouselUpdating = false;
      if (pendingCarouselUpdate && isCarouselDrawerOpen) {
        pendingCarouselUpdate = false;
        setTimeout(function() {
          if (isCarouselDrawerOpen) {
            loadComplementaryProducts(true);
          }
        }, 0);
      } else {
        pendingCarouselUpdate = false;
      }
    }
  }
  
  function startCarouselPolling() {
    stopCarouselPolling();

    carouselStartTimeout = setTimeout(function() {
      carouselStartTimeout = null;
      if (isCarouselDrawerOpen) {
        loadComplementaryProducts(true);
      }
    }, 400);
  }

  function stopCarouselPolling() {
    if (carouselStartTimeout) {
      clearTimeout(carouselStartTimeout);
      carouselStartTimeout = null;
    }
    if (carouselRefreshTimeout) {
      clearTimeout(carouselRefreshTimeout);
      carouselRefreshTimeout = null;
    }
  }
  
  document.addEventListener('toggle', function(event) {
    if (event.target?.id !== 'cart-drawer') return;
    if (event.target.open) {
      isCarouselDrawerOpen = true;
      startCarouselPolling();
    } else {
      isCarouselDrawerOpen = false;
      pendingCarouselUpdate = false;
      stopCarouselPolling();
    }
  }, true);

  document.addEventListener('cart:refresh', function() {
    if (isCarouselDrawerOpen) {
      clearTimeout(carouselRefreshTimeout);
      carouselRefreshTimeout = setTimeout(function() {
        carouselRefreshTimeout = null;
        if (isCarouselDrawerOpen) loadComplementaryProducts(true);
      }, 350);
    }
  });

  document.addEventListener('cart:count-changed', function() {
    lastCartItemsString = '';
    if (isCarouselDrawerOpen) {
      clearTimeout(carouselRefreshTimeout);
      carouselRefreshTimeout = setTimeout(function() {
        carouselRefreshTimeout = null;
        if (isCarouselDrawerOpen) loadComplementaryProducts(true);
      }, 350);
    }
  });

})();